export default [
  {
    url: "/Overview",
    name: "Overview",
    icon: "HomeIcon",
    slug: "overview",
    i18n: "Overview",
  },
  {
    url: "/company-profile",
    slug: "company-settings",
    name: "Company Settings",
    icon: "UserIcon",
    i18n: "CompanyProfile",
  },
  {
    url: null,
    name: "ELD",
    icon: "MonitorIcon",
    i18n: "ELDs",
    submenu: [
      {
        url: "/drivers",
        name: "Drivers",
        icon: "",
        slug: "drivers",
        i18n: "Drivers",
      },
      {
        url: "/logs",
        name: "logs",
        slug: "logs",
        i18n: "Logs",
      },
      {
        url: "/logs-driver",
        name: "logs-driver",
        slug: "logs-driver",
        i18n: "Logs by driver",
      },
      {
        url: "/trackings",
        name: "trackings",
        slug: "trackings",
        i18n: "Trackings",
      },
      {
        url: "/driving-events",
        name: "driving-events",
        slug: "driving-events",
        i18n: "Driving",
      },
      {
        url: "/vehicles",
        name: "vehicles",
        slug: "vehicles",
        i18n: "Vehicles",
      },
      // {
      //   url: '/elds',
      //   name: 'elds',
      //   slug: 'elds',
      //   i18n: 'ELDs'
      // },
      // {
      //   url: '/transfer-eld-data',
      //   name: 'Transfer',
      //   slug: 'transfer-eld-data',
      //   i18n: 'Transfer'
      // }
    ],
  },

  {
    url: null,
    name: "Reports",
    icon: "ClipboardIcon",
    i18n: "Reports",
    submenu: [
      {
        url: "/ifta-reports",
        slug: "Ifta report",
        name: "Ifta report",
        i18n: "Ifta report",
      },
      {
        url: "/activity-reports",
        slug: "Activity report",
        name: "Activity report",
        i18n: "Activity report",
      },
      {
        url: "/driver-reports",
        slug: "Driver report",
        name: "Driver report",
        i18n: "Driver report",
      },
      {
        url: "/fmcsa-reports",
        slug: "FMCSA report",
        name: "FMCSA report",
        i18n: "FMCSA report",
      },
    ],
  },
  {
    url: null,
    name: "Settings",
    icon: "SettingsIcon",
    i18n: "Settings",
    submenu: [
      {
        url: "/settings",
        slug: "settings",
        name: "Settings",
        icon: "SettingsIcon",
        i18n: "Settings",
      },
      {
        url: "/reports",
        slug: "reports",
        name: "Reports",
        icon: "BarChartIcon",
        i18n: "Reports",
      },
    ],
  },
];
